module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": _vm.tooltipTitle
    }
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.order.techcenter.city.name) + " - " + _vm._s(_vm.order.techcenter.company.name) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    style: ({
      backgroundColor: _vm.order.techcenter.color
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.viewTechcenter($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.order.techcenter.address))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9d5ac70", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-e9d5ac70"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderTechcenterInfo.vue
// module id = 1078
// module chunks = 1